import { postRequest } from '../clients/axios';
import { SavePlayerWithBioPayload, SavePlayerWithBioResponse } from '../models';

export const postSavePlayerWithBio = async (data: SavePlayerWithBioPayload) => {
  const url = 'player/SavePlayerWithBio';
  const response = await postRequest<SavePlayerWithBioResponse>(url, data);
  return response;
};
